import { createQueryHook } from '../internal/createQueryHook';
import { segments } from '../queries/segments';

/**
 * @deprecated Use `segments.detail()` with `useQuery` directly.
 */
export const useSegment = createQueryHook(
  ({ projectKey, environmentKey, segmentKey }: { projectKey: string; environmentKey: string; segmentKey: string }) =>
    segments.detail({ projectKey, environmentKey, segmentKey }),
);
